import React from 'react'

function VisionMission() {
   return (
      <section className="cs-bg-secondary pb-5 pt-5">
         <div className="container">
            <div className="row cs-bg-theme-color-2 rounded-5 mt-4 gap-3  gx-5 mb-4 about-vision">
               <div className="col-xl-3 d-none d-lg-flex comman_disc_card justify-content-center align-items-center cs-bg-primary rounded-5">
                  <div className="text-center">
                     <div className="image-container m-auto text-center p-5">
                        <img
                           src="/assets/svg/discover/vision.svg"
                           className="w-100"
                           alt="Original Image"
                        />
                     </div>
                  </div>
               </div>
               <div className="col about-us-content cs-text-secondary  ">
                  <h3 className="about-us-content-title">
                     Where we’re headed (Vision)
                  </h3>
                  <div className="about-us-border-line"></div>
                  <p className="about-us-content-description mt-4">
                     We’re chasing a world where tech doesn’t frustrate—it flows
                     like a river carving its own path. Every line of code we
                     hammer out is a brick in a future where tools don’t just
                     function—they vanish into the background, so intuitive you
                     barely notice them working their magic.
                  </p>
                  <p className="about-us-content-description">
                     We’re talking apps that anticipate your next move before
                     you make it, software that bends to your rhythm without a
                     hiccup, and systems so smooth they fuel the wildest dreams
                     without ever breaking a sweat. Since 2013, we’ve been
                     pushing toward this: a digital landscape where the boldest
                     ideas don’t crash into tech roadblocks—they soar over them,
                     powered by solutions that feel like second nature.
                  </p>
               </div>
            </div>
            <div className="row cs-bg-theme-color-2 rounded-5 gap-3  gx-5 about-vision  about-vision-second">
               <div className="col about-us-content cs-text-secondary  ">
                  <h3 className="about-us-content-title">
                     How we roll (Mission)
                  </h3>
                  <div className="about-us-border-line"></div>
                  <p className="about-us-content-description mt-4">
                     We craft software and apps that tackle real problems
                     head-on, not just pile up shiny features for the sake of a
                     spec sheet. It starts with listening—really listening—to
                     the headaches, the what-ifs, and the crazy ambitions others
                     might shrug off. Then we build smart: solutions that cut
                     through the clutter with surgical precision, designed to
                     fit like a glove and run like a rocket.
                  </p>
                  <p className="about-us-content-description">
                     Speed’s our signature—we ship fast, iterate faster, and
                     don’t quit until it’s not just done, but damn good. We’ve
                     been at this since 2013, stripping away the noise so tech
                     doesn’t slow down the limit-pushers—it propels them, giving
                     the dreamers, the doers, and the rule-breakers the tools to
                     rewrite what’s possible.
                  </p>
               </div>
               <div className="col-xl-3 d-none d-lg-flex align-items-center  comman_disc_card justify-content-center cs-bg-primary rounded-5">
                  <div className="text-center">
                     <div className="m-auto text-center p-5 h-100 image-container1">
                        <img
                           src="/assets/svg/discover/mission.svg"
                           className="w-100"
                        />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default VisionMission
